import { styledComponentWithProps } from '../../Styled/Shared'
import styled, { sProp } from '../../../theme/styled'

type SidebarProps = {
  altBg?: boolean
}

const sidebarProp = sProp(['sidebar', 'body'])

export const SidebarWrapper = styledComponentWithProps<SidebarProps>(
  styled.div
)`
  width: 320px;
  min-width: 320px;

  flex-direction: column;
  justify-content: flex-start;
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;

  color: ${sidebarProp('color')};
  background: ${({ altBg, theme }) =>
    altBg ? theme.sidebar.body.altBackground : theme.sidebar.body.background};

  .sidebar-content {
    padding: 25px;
    padding-bottom: 61px;
    flex: 1 0 auto;
    display: flex;
    position: relative;
    flex-direction: column;
    font-size: ${({ theme }) => theme.sidebar.body.fontSize};
  }

  h3.sidebar-title {
    color: ${({ theme }) => theme.sidebar.title.color};
    background: ${({ theme }) => theme.sidebar.title.background};
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.sidebar.title.fontSize};
    padding: 7px 20px;
    line-height: 16px; // 30 - 2 * padding
    height: 30px;
    font-weight: bold;

    img {
      height: 13px;
      float: right;
      margin-top: 2px;
      margin-right: 7px;
    }

    .active {
      transform: rotate( 90deg );
    }
  }

  .sidebar-toolbar {
    height: 50px;
    margin: 0;
    padding: 5px;
    border-bottom: 1px solid #dde1e3;
  }
`

export const ColumnHeader = styled.div`
  height: 30px;
  min-height: 30px;
  font-size: ${({ theme }) => theme.sidebar.header.fontSize};
  margin: 0;
  padding: 7px 20px;
  line-height: 16px;
  background: ${({ theme }) => theme.sidebar.header.background};
`

export const SidebarBody = styled.div`
  color: ${sidebarProp('color')};
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  transition: opacity 0.5s;
  font-size: ${({ theme }) => theme.sidebar.body.fontSize};

  .ingress {
    font-weight: 600;
    margin: 5px 0 15px;
  }

  h3 {
    font-size: 20px;
    font-weight: bold;
    margin: 10px 0 20px;
  }

  h4 {
    margin: 20px 0 10px;
    ${({ theme }) => theme.sidebar.title.fontSize};
  }

  h5 {
    align-self: flex-start;
    margin-bottom: 10px;
  }

  h5,
  label {
    font-weight: 600;
  }

  hr {
    border: none;
    height: 1px;
    color: ${({ theme }) => theme.colors.inactive};
    background: ${({ theme }) => theme.colors.inactive};
    width: 100%;
    margin: 10px 0 10px;
  }

  label {
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  input {
    border: 1px solid ${({ theme }) => theme.colors.inactive};
    height: 35px;
    width: 170px;

    margin-left: auto;
    padding: 5px 10px;
    font-weight: 600;
    font-size: ${({ theme }) => theme.sidebar.body.fontSize};
    color: ${({ theme }) => theme.colors.default};
  }

  input[type='radio'] {
    width: auto;
    height: 15px;
    margin-left: 0;
  }

  input[type='number'] {
    appearance: textfield;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  input[type='checkbox'] {
    width: auto;
  }

  input.with-units {
    padding-right: 30px;
  }

  label.read-only-value {
    color: ${({ theme }) => theme.colors.inactive};
  }

  input:disabled,
  input.read-only-value {
    border: 1px solid ${({ theme }) => theme.colors.inactive};
    color: ${({ theme }) => theme.colors.inactive};
    background: ${({ theme }) => theme.colors.invert};
  }

  input.error {
    border: 1px solid ${({ theme }) => theme.colors.error};
  }

  select:disabled {
    background: ${({ theme }) => theme.colors.inactive};
  }

  textarea {
    border: 1px solid ${({ theme }) => theme.colors.light};
    border-radius: 0px;
    height: 100px;
    width: 100%;
  }

  hr.full-width {
    margin-left: -25px;
    margin-right: -25px;
    width: auto;
  }

  .center-contents {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Shared/Sidebar/SidebarStyles.tsx